import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.textContent)?_c('div',{staticClass:"text_modal_content_wrapper"},[_c(VDialog,{attrs:{"max-width":"600px"},on:{"click:outside":_vm.toggleModal},model:{value:(_vm.modalIsActive),callback:function ($$v) {_vm.modalIsActive=$$v},expression:"modalIsActive"}},[_c(VCard,[(_vm.title)?_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"text_contet_wrapper"},[_vm._v(" "+_vm._s(_vm.textContent)+" ")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }